import React, { useState, useContext, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  const { isDark } = useContext(StyleContext);

  const [selectedTag, setSelectedTag] = useState("All");

  if (!bigProjects.display) {
    return null;
  }

  // 🔥 Extract all unique tags
  const tags = [
    "All",
    ...new Set(
      bigProjects.projects.flatMap((p) => p.tags || [])
    )
  ];

  // 🔥 Filter logic
  const filteredProjects =
    selectedTag === "All"
      ? bigProjects.projects
      : bigProjects.projects.filter((p) =>
          p.tags?.includes(selectedTag)
        );

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="projects-heading">{bigProjects.title}</h1>

          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>


   

          {/* 🔥 FILTER TAGS */}
         <div className="filter-container">
            { bigProjects.showFilter && tags.map((tag, i) => (
              <span
                key={i}
                className={`filter-tag ${
                  selectedTag === tag ? "active" : ""
                }`}
                // onClick={() => setSelectedTag(tag)}
                  onClick={() => {
setSelectedTag(tag);

  window.tracker?.track(`filter_project_tag_${tag||"-"}`, {
    
  });
}}
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="projects-container">
            {filteredProjects.map((project, i) => {
              return (
                <ProjectCard
                  key={i}
                  project={project}
                  isDark={isDark}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}

function ProjectCard({ project, isDark }) {
  const [expanded, setExpanded] = useState(false);
  const [dominantColor, setDominantColor] = useState(null);
  const imgRef = useRef(null);
  const cardRef = useRef(null);
  const modalContentRef = useRef(null);

  function openUrlInNewTab(url, e) {
    if (!url) return;
    e.stopPropagation();
    var win = window.open(url, "_blank");
    win.focus();
  }

  const generateFallbackColor = (projectName) => {
    let hash = 0;
    for (let i = 0; i < projectName?.length; i++) {
      hash = projectName.charCodeAt(i) + ((hash << 5) - hash);
    }

    const r = 50 + Math.abs(hash % 150);
    const g = 50 + Math.abs((hash >> 8) % 150);
    const b = 50 + Math.abs((hash >> 16) % 150);

    return `rgb(${r}, ${g}, ${b})`;
  };

  useEffect(() => {
    const extractColor = (img) => {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = 50;
        canvas.height = 50;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(
          0,
          0,
          canvas.width,
          canvas.height
        ).data;

        let r = 0,
          g = 0,
          b = 0,
          count = 0;

        for (let i = 0; i < imageData?.length; i += 20) {
          r += imageData[i];
          g += imageData[i + 1];
          b += imageData[i + 2];
          count++;
        }

        r = Math.min(255, Math.max(50, Math.floor(r / count)));
        g = Math.min(255, Math.max(50, Math.floor(g / count)));
        b = Math.min(255, Math.max(50, Math.floor(b / count)));

        return `rgb(${r}, ${g}, ${b})`;
      } catch (error) {
        return generateFallbackColor(project.projectName);
      }
    };

    if (!dominantColor) {
      setDominantColor(generateFallbackColor(project.projectName));
    }

    const img = imgRef.current;
    if (img && project.image) {
      if (img.complete) {
        setDominantColor(extractColor(img));
      } else {
        const handleLoad = () => {
          requestAnimationFrame(() => {
            setDominantColor(extractColor(img));
          });
        };

        img.addEventListener("load", handleLoad);
        return () => img.removeEventListener("load", handleLoad);
      }
    }
  }, [project.projectName, dominantColor, project.image]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expanded &&
        cardRef.current &&
        !cardRef.current.contains(event.target)
      ) {
        setExpanded(false);
      }
    };

    if (expanded) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  useEffect(() => {
    if (expanded) {
      document.body.style.overflow = "hidden";
      if (modalContentRef.current) {
        modalContentRef.current.scrollTop = 0;
      }
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [expanded]);

  const toggleExpand = () => {
  const newState = !expanded;
  setExpanded(newState);

  // 🔥 TRACK EVENT WHEN OPENING
  if (newState && window.tracker) {
    window.tracker.track(`view_personal_project_${project.projectName || "-"}`, {
      name: project.projectName
    });
  }
};  

  return (
    <>
      <div
        className={`${
          isDark
            ? "project-card project-card-dark"
            : "project-card project-card-light"
        }`}
        onClick={!expanded ? toggleExpand : undefined}
      >
        <div style={{ background: dominantColor }} className="project-banner">
          <div className="project-blurred-div"></div>

          <div className="project-div-name">
            <h5 className="project-text-name">{project.projectName}</h5>
          </div>

          {project.image && (
            <img
              ref={imgRef}
              crossOrigin="anonymous"
              className="project-roundedimg"
              src={project.image}
              alt={project.projectName}
            />
          )}
        </div>

        <div className="project-text-details">
          <h5
            className={
              isDark
                ? "project-text-role dark-mode-text"
                : "project-text-role"
            }
          >
            {project.projectName}
          </h5>

          <p
            className={
              isDark
                ? "subTitle project-text-desc dark-mode-text"
                : "subTitle project-text-desc"
            }
          >
            {project.projectDesc}
          </p>

          <button
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand();
            }}
            className={`view-details-btn ${isDark ? "dark-mode-btn" : ""}`}
          >
            View Details
          </button>
        </div>
      </div>

      {expanded &&
        createPortal(
          <div className="project-modal-overlay">
            <div
              ref={cardRef}
              className={`project-modal ${
                isDark ? "project-modal-dark" : ""
              }`}
              style={{ "--card-color": dominantColor }}
            >
              <button
                className="project-modal-close"
                onClick={toggleExpand}
              >
                ×
              </button>

              <div className="project-modal-header">
                {project.image && (
                  <img
                    className="project-modal-img"
                    src={project.image}
                    alt={project.projectName}
                  />
                )}
                <div className="project-modal-title">
                  <h3>{project.projectName}</h3>
                </div>
              </div>

              <div ref={modalContentRef} className="project-modal-content">
                <div className="project-modal-description">
                  <h5>Description</h5>
                  <p>{project.projectDesc}</p>
                </div>

                 {project.footerLink && (
                  <div className="project-modal-links">
                    <h5>Links & Resources</h5>
                    <div className="project-modal-footer">
                      {project.footerLink.map((link, i) => (
                        <span
                          key={i}
                          className={
                            isDark ? "dark-mode project-modal-tag" : "project-modal-tag"
                          }
                          onClick={(e) => openUrlInNewTab(link.url, e)}
                          style={{ background: project.projectName === "Prompter Studio" || project.projectName === "CFA Financial Analysis (Power BI)" || project.projectName === "PlagAI Guard" ?  'rgb(50, 50, 133)':dominantColor }}
                        >
                          {link.name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}